export default "__VITE_ASSET__B7_yhMO6__"